export default __webpack_public_path__ + "ec2220631d2dcc280d47814de5b99a2b.png";